import { Application } from 'app/shared/services/app/application/application.model';
import { Validators, AbstractControl } from '@angular/forms';

export class ApplicationCreationValidators {
    static apps: Application[];

    static cannotContainSpace(control: AbstractControl) {
        if (control.value && control.value.indexOf(' ') >= 0) return {cannotContainSpace: true};
        return null;
    }

    static mustBePackage(control: AbstractControl) {
        //Should have a period, shouldn't be first character
        let patternPackage = /^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$/i;
        if (control.value && !patternPackage.test(control.value)) return {mustBePackage: true};
        return null;
    }

    static cannotContainSpecial(control: AbstractControl) {
        let pattern = /^[\w]+$/;
        //regex does recognize underscore as valid character here.
        //this does allow numbers
        if (control.value && !pattern.test(control.value)) return {cannotContainSpecial: true};
        return null;
    }

    static mustBeVersion(control: AbstractControl) {
        let pattern = /^\d+(\.\d+)+$/g;
        if (control.value && !pattern.test(control.value)) return {mustBeVersion: true};
        return null;
    }

    static mustBeHexColor(control: AbstractControl) {
        let pattern = /^#+([a-fA-F0-9]{6})$/;
        if(control.value && !pattern.test('#' + control.value)) {return {mustBeHexColor: true};}
        else {return null;}
    }

    static sysNameMustBeUnique(control: AbstractControl)  {
        let apps = ApplicationCreationValidators.apps;
        if (apps) {
          let val:string = control.value;
          let matchingApps = apps.filter((app) => app.sys_name === val);
          if (matchingApps.length > 0) return {sysNameMustBeUnique: true};
        }
        return null;
    }

    static pkgNameMustBeUnique(control: AbstractControl) {
      let apps = ApplicationCreationValidators.apps;
      if (apps) {
        let val: string = control.value;
        let matchingApps = apps.filter((app) => app.settings.package === val);
        if (matchingApps.length > 0) return {pkgNameMustBeUnique: true};
      }
      return null;
    }

    static mustBeFacebookUserName(control: AbstractControl) {
        let pattern = /^[a-z0-9.]{5,50}$/;
        if(control.value && !pattern.test(control.value.toLocaleLowerCase())) return {mustBeFacebookUserName: true}
        else {return null;}
    }

    static mustBeTwitterHandle(control: AbstractControl) {
        let pattern = /^[a-z0-9_]{1,15}$/;
        if(control.value && !pattern.test(control.value.toLocaleLowerCase())) return {mustBeTwitterHandle: true}
        else {return null;}
    }

    static mustBeInstagramUsername(control: AbstractControl) {
        let pattern = /^[a-z0-9_.]{1,30}$/;
        if(control.value && !pattern.test(control.value.toLocaleLowerCase())) return {mustBeInstagramUsername: true}
        else {return null;}
    }

    static mustBeLinkedinUsername(control: AbstractControl) {
        let pattern = /^[a-z0-9]{5,30}$/;
        if(control.value && !pattern.test(control.value.toLocaleLowerCase())) return {mustBeLinkedinUsername: true}
        else {return null;}
    }

    static mustBeSoundcloudUsername(control: AbstractControl) {
        let controlValue: string = control.value;
        let pattern = /^[a-z0-9_-]{1,25}$/;
        if(control.value && !pattern.test(control.value.toLocaleLowerCase())) return {mustBeSoundcloudUsername: true}
        else {return null;}
    }

    static mustBeYoutubeChannel(control: AbstractControl) {
        let pattern = /^[a-z0-9]{1,20}$/;
        if(control.value && !pattern.test(control.value.toLocaleLowerCase())) return {mustBeYoutubeChannel: true}
        else {return null;}
    }
}



// WEBPACK FOOTER //
// /app/src/app/validators/app-create/app-creation-validators.ts